import { DataTable } from '../../common/DataTable';
import { StatusBadge } from '../../common/StatusBadge';
import type { Subscription } from '../../../models/Subscription';
import { formatDate } from '../../../utils/date';

export const SubscriptionsTab = ({ items }: { items: Subscription[] }) => (
  <DataTable
    items={items}
    columns={[
      { columnId: 'sku', label: 'SKU', renderCell: (item) => item.cr_crm_skuname },
      { columnId: 'qty', label: 'Qty', renderCell: (item) => item.cr_crm_quantity },
      { columnId: 'billing', label: 'Billing', renderCell: (item) => item.cr_crm_billingcycle ?? '—' },
      { columnId: 'renewal', label: 'Renewal', renderCell: (item) => formatDate(item.cr_crm_renewaldate ?? item.cr_crm_enddate) },
      { columnId: 'status', label: 'Status', renderCell: (item) => <StatusBadge value={item.cr_crm_status} /> },
    ]}
    getRowId={(item) => item.cr_crm_subscriptionid}
    page={1}
    pageCount={1}
    totalItems={items.length}
    onPageChange={() => undefined}
  />
);
